export function toGetParams(params) {
  const result = [];

  for (const key in params)
  {
    if (params.hasOwnProperty(key))
    {
      result.push(`${key}=${params[key]}`);
    }
  }

  return result.join('&');
}
